import logoIcon from "@assets/images/main-icon.png"; // TODO: replace with main-icon.svg
import MainLogoDark from "@assets/images/main-logo-dark.svg";

import { cn } from "@utils/tailwind.util";

interface Props {
  className?: string;
}

export function MainLogo({ className }: Props) {
  return (
    <header className={cn("flex items-center justify-center gap-2 dark:text-white80", className)}>
      <img src={logoIcon} className="min-w-7 h-7 flex-shrink-0" alt="logo icon" />
      <MainLogoDark width={92} height={18} />
    </header>
  );
}
